import BadgesValue from "./BadgesValue";

export default class BadgesModel {
    public general: any[] = [];
    public predictor: BadgesValue[] = [];
    public topX: BadgesValue[] = [];
    public matchQuiz: BadgesValue[] = [];
}